import React from "react"

import ItemPage from "../components/weapons"

export default () => <ItemPage></ItemPage>